
    // import infoList from './infoList.vue'
    import {useStore} from "@/store";
    import reportMsgUt from "@/util/reportMsg";
    import DetectPlayer from '@/views/components/ALvideoPlayer/index.vue';
    import '@souche-ui/cyp_aliyunplayer/lib/styles/index.css';
    import {useRouter, useRoute} from "vue-router";
    import {defineComponent, computed, ComputedRef, watch, toRefs, reactive} from "vue";
    import {getVideoPlayAuth} from '@/service'
    interface State {
        playAuth: string;
        loopVideo: any;
        videoId: string;
        playData: any;
        reportMsg: object;
        videoInfo: object[];
        firstImage: string;
        address: string;
    }

    export default defineComponent({
        name: "videoCom",
        props: {
            videoData: {
                type: Object,
                default: () => {
                    return {}
                }
            }
        },
        setup(props: any) {
            let state: State = reactive({
                playAuth: '',
                loopVideo: {},
                videoId: '',
                playData: null,
                reportMsg: {},
                videoInfo: [],
                firstImage: '',
                address: ''
            })
            let store = useStore()
            const router = useRouter();
            const {query} = useRoute();
            const {templateCode} = query;
            const {videoData} = toRefs(props);
            state.videoId = videoData.value.videoId
            state.firstImage = videoData.value.firstImage
            state.address = videoData.value.address
            // state.templateCode = String(templateCode) || ''
            state.reportMsg = reportMsgUt;
            const getPlayAuth = function (videoId) {
                videoId && getVideoPlayAuth({videoId}).then((res: any) => {
                    state.playAuth = res;
                    state.playData = {
                        playAuth: res,
                        vodId: state.videoId,
                        cover: state.firstImage,
                        autoplay: false,
                    }
                });
            };
            // getPlayAuth(state.videoId);
            watch(videoData, (data: any) => {
                // state.dataList = basicItemInfos
                state.videoId = videoData.value.videoId
                state.firstImage = videoData.value.firstImage
                state.address = videoData.value.address
                getPlayAuth(state.videoId);
                console.log('videoId:', state.videoId);
            }, {immediate: true})
            return {
                state,
                router,
                store,
                getPlayAuth
            }
        },
        components: {
            DetectPlayer
        },
        methods: {
            
        }
    })
